const FormattedNumberInput = ({ value, onChange, placeholder, id ,className}) => {
  const handleChange = (e) => {
    const raw = e.target.value.replace(/,/g, "");
    if (/^\d*$/.test(raw)) {
      onChange(Number(raw));
    }
  };

  return (
    <div className="price-input-group2 relative ">
      <input
        type="text"
        className={`search-input text-sm py-2 pl-2 pr-12 drop-height ${className}`}
        id={id}
        placeholder={placeholder}
        value={value === 0 ? "" : value.toLocaleString("en-US")}
        onChange={handleChange}
      />
    </div>
  );
};

export default FormattedNumberInput;
